/**
 * PendingTasksWidget – „Wartet auf mich"
 *
 * Aggregiert alle Aufgaben, die zur Freigabe durch den/die User:in offen sind:
 * Urlaubs-, Zeitkorrektur-, Stammdaten- und Qualifikations-Anträge.
 * Wird nur angezeigt, wenn mindestens ein Eintrag offen ist.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';
import { Inbox, Calendar, Clock, FileText, GraduationCap, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePendingTasks } from '../../contexts/PendingTasksContext';

const ICON_MAP = {
  Calendar, Clock, FileText, GraduationCap,
};

export const PendingTasksWidget = () => {
  const { total, items } = usePendingTasks();
  const navigate = useNavigate();

  if (total === 0) return null;

  return (
    <Card className="border-primary/40 bg-primary/5" data-testid="pending-tasks-widget">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <CardTitle className="font-heading flex items-center gap-2 text-base">
            <Inbox className="h-4 w-4 text-primary" />
            Wartet auf mich
          </CardTitle>
          <Badge className="bg-primary text-primary-foreground" data-testid="pending-tasks-total">
            {total}
          </Badge>
        </div>
        <CardDescription className="text-xs">
          Aufgaben, die deine Freigabe brauchen
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-1">
        {items.map((it) => {
          const Icon = ICON_MAP[it.icon] || FileText;
          return (
            <button
              key={it.category}
              type="button"
              onClick={() => navigate(it.link)}
              className="w-full flex items-center justify-between gap-2 rounded-md px-3 py-2 hover:bg-primary/10 transition-colors text-left"
              data-testid={`pending-tasks-item-${it.category}`}
            >
              <span className="flex items-center gap-2 min-w-0">
                <Icon className="h-4 w-4 text-primary shrink-0" />
                <span className="text-sm truncate">{it.label}</span>
              </span>
              <span className="flex items-center gap-2 shrink-0">
                <Badge variant="outline" className="text-xs bg-white dark:bg-card">
                  {it.count}
                </Badge>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
              </span>
            </button>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default PendingTasksWidget;
